// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3seJQ","choiceBoxes":"toolbarselects_choiceBoxes__35eBh","simpleField":"toolbarselects_simpleField__NVIim"};